module.exports = __webpack_public_path__ + "img/Document-Finish-Popup-en.24c346f.png";